import React, { useEffect, useRef, useState } from 'react';
import styles from './../addCategoryForm/addCategoryForm.module.css';
import { Close, closeCircle, UploadImg } from '../../Svg';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Country, State } from "country-state-city";
import { addCustomerThunk } from '../../redux/customer/customerSlice';
import { getAllAdminThunk } from '../../redux/admin/adminSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const AddCustomerForm = () => {

    const { admin } = useSelector((state) => state?.admin)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);

    const [showPassword, setShowPassword] = useState({
        new: false,
        confirm: false,
    });

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    // Fetch countries on component mount
    useEffect(() => {
        const countryList = Country.getAllCountries();
        setCountries(countryList);
    }, []);




    // Define the Formik schema
    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({
        initialValues: {
            fullName: "",
            phone: "",
            email: "",
            companyName: "",
            gstn: "",
            password: "",
            confirmPassword: "",
            billingAddress: {
                factoryUnits: "",
                streetAddress: "",
                country: "",
                state: "",
                zipCode: "",
            },
            shippingAddress: {
                factoryUnits: "",
                streetAddress: "",
                country: "",
                state: "",
                zipCode: "",
            },
            activeStatus: "",
            level: "",
            admin: "",
            creditTerms: "",
            status: "APPROVED"

        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            fullName: Yup.string().required('Name is required'),
            phone: Yup.string().required('Phone number is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            companyName: Yup.string().required('Company name is required'),
            gstn: Yup.string().required('GSTN number is required'),
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm password is required'),
            billingAddress: Yup.object().shape({
                factoryUnits: Yup.string().required('Factory unit is required'),
                streetAddress: Yup.string().required('streetAddress is required'),
                country: Yup.string().required('Country is required'),
                state: Yup.string().required('State is required'),
                zipCode: Yup.string().required('Zip code is required'),
            }),
            shippingAddress: Yup.object().shape({
                factoryUnits: Yup.string().required('Factory unit is required'),
                streetAddress: Yup.string().required('streetAddress is required'),
                country: Yup.string().required('Country is required'),
                state: Yup.string().required('State is required'),
                zipCode: Yup.string().required('Zip code is required'),
            }),
            activeStatus: Yup.string().required('status is required'),

        }),

        onSubmit: async (values) => {
            const formattedValues = {
                ...values,
                admin: values.admin ? values.admin : null
            };
            const status = await dispatch(addCustomerThunk(formattedValues))
            console.log(status);

            if (status.payload === 200) {
                navigate(-1)
            }
        },
    });



    // Update states when a country is selected
    const handleCountryChange = (field, countryName) => {
        const selectedCountry = countries.find((country) => country.name === countryName);
        if (selectedCountry) {
            const stateList = State.getStatesOfCountry(selectedCountry.isoCode);
            setStates(stateList);
            setFieldValue(field, countryName); // Set country name
            setFieldValue(field.replace("country", "state"), ""); // Reset state
        }
    };


    return (
        <>
            <form onSubmit={handleSubmit} className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>General Information</h2>

                            <label className={styles.addCatLabel}>
                                Full name
                                <input
                                    type="text"
                                    name="fullName"
                                    placeholder="Full name"
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.fullName}
                                />
                                {touched.fullName && errors.fullName ? (
                                    <div className={styles.errorText}>{errors.fullName}</div>
                                ) : null}
                            </label>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Phone number
                                    <input
                                        type="phone"
                                        name="phone"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.phone}
                                    />
                                    {touched.phone && errors.phone ? (
                                        <div className={styles.errorText}>{errors.phone}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Email id
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                    />
                                    {touched.email && errors.email ? (
                                        <div className={styles.errorText}>{errors.email}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Company name
                                    <input
                                        type="text"
                                        name="companyName"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.companyName}
                                    />
                                    {touched.companyName && errors.companyName ? (
                                        <div className={styles.errorText}>{errors.companyName}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    GSTN number
                                    <input
                                        type="text"
                                        name="gstn"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.gstn}
                                    />
                                    {touched.gstn && errors.gstn ? (
                                        <div className={styles.errorText}>{errors.gstn}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                             type={showPassword.new ? 'text' : 'password'}
                                            name="password"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                        />
                                        <FontAwesomeIcon
                                           icon={showPassword.new ? faEyeSlash : faEye}
                                            className={styles.loginpasswordIcon}
                                            onClick={() => togglePasswordVisibility('new')}
                                        />
                                    </div>
                                    {touched.password && errors.password ? (
                                        <div className={styles.errorText}>{errors.password}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Confirm password
                                    <div className={styles.logininputContainer}>
                                        <input
                                             type={showPassword.confirm ? 'text' : 'password'}
                                            name="confirmPassword"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.confirmPassword}
                                        />
                                        <FontAwesomeIcon
                                               icon={showPassword.confirm ? faEyeSlash : faEye}
                                            className={styles.loginpasswordIcon}
                                            onClick={() => togglePasswordVisibility('confirm')}
                                        />
                                    </div>
                                    {touched.confirmPassword && errors.confirmPassword ? (
                                        <div className={styles.errorText}>{errors.confirmPassword}</div>
                                    ) : null}
                                </label>
                            </div>



                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Billing address</h2>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    Factory Units
                                    <select
                                        className={styles.addCatSelect}
                                        name="billingAddress.factoryUnits"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.billingAddress.factoryUnits}
                                    >
                                        <option value="">Select</option>
                                        <option value="Unit 1">Unit 1</option>
                                        <option value="Unit 2">Unit 2</option>
                                    </select>
                                    {touched.billingAddress?.factoryUnits && errors.billingAddress?.factoryUnits ? (
                                        <div className={styles.errorText}>{errors.billingAddress.factoryUnits}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '67%' }}>
                                    Street, area, city
                                    <input
                                        type="text"
                                        name="billingAddress.streetAddress"
                                        placeholder="Enter street address"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.billingAddress.streetAddress}
                                        className={styles.addCatInput}
                                    />
                                    {touched.billingAddress?.streetAddress && errors.billingAddress?.streetAddress ? (
                                        <div className={styles.errorText}>{errors.billingAddress.streetAddress}</div>
                                    ) : null}
                                </label>

                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    Country
                                    <select
                                        className={styles.addCatSelect}
                                        name="billingAddress.country"
                                        value={values.billingAddress.country}
                                        onChange={(e) => handleCountryChange("billingAddress.country", e.target.value)}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">Select</option>{countries.map((country) => (
                                            <option key={country.isoCode} value={country.name}>
                                                {country.name}
                                            </option>
                                        ))}

                                    </select>
                                    {touched.billingAddress?.country && errors.billingAddress?.country && (
                                        <div className={styles.errorText}>{errors.billingAddress.country}</div>
                                    )}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    State
                                    <select
                                        className={styles.addCatSelect}
                                        name="billingAddress.state"
                                        value={values.billingAddress.state}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">Select</option>
                                        {states.map((state) => (
                                            <option key={state.isoCode} value={state.name}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                    {touched.billingAddress?.state && errors.billingAddress?.state && (
                                        <div className={styles.errorText}>{errors.billingAddress.state}</div>
                                    )}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    Zip code
                                    <input
                                        type="text"
                                        name="billingAddress.zipCode"
                                        placeholder="Enter Zip code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.billingAddress.zipCode}
                                        className={styles.addCatInput}
                                    />
                                    {touched.billingAddress?.zipCode && errors.billingAddress?.zipCode ? (
                                        <div className={styles.errorText}>{errors.billingAddress.zipCode}</div>
                                    ) : null}
                                </label>
                            </div>
                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Shipping address</h2>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    Factory Units
                                    <select
                                        className={styles.addCatSelect}
                                        name="shippingAddress.factoryUnits"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shippingAddress.factoryUnits}
                                    >
                                        <option value="">Select</option>
                                        <option value="Unit 1">Unit 1</option>
                                        <option value="Unit 2">Unit 2</option>
                                    </select>
                                    {touched.shippingAddress?.factoryUnits && errors.shippingAddress?.factoryUnits ? (
                                        <div className={styles.errorText}>{errors.shippingAddress.factoryUnits}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '67%' }}>
                                    Street, area, city
                                    <input
                                        type="text"
                                        name="shippingAddress.streetAddress"
                                        placeholder="Enter street address"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shippingAddress.streetAddress}
                                        className={styles.addCatInput}
                                    />
                                    {touched.shippingAddress?.streetAddress && errors.shippingAddress?.streetAddress ? (
                                        <div className={styles.errorText}>{errors.shippingAddress.streetAddress}</div>
                                    ) : null}
                                </label>

                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    Country
                                    <select
                                        className={styles.addCatSelect}
                                        name="shippingAddress.country"
                                        value={values.shippingAddress.country}
                                        onChange={(e) => handleCountryChange("shippingAddress.country", e.target.value)}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">Select</option>
                                        {countries.map((country) => (
                                            <option key={country.isoCode} value={country.name}>
                                                {country.name}
                                            </option>
                                        ))}

                                    </select>
                                    {touched.shippingAddress?.country && errors.shippingAddress?.country && (
                                        <div className={styles.errorText}>{errors.shippingAddress.country}</div>
                                    )}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    State
                                    <select
                                        className={styles.addCatSelect}
                                        name="shippingAddress.state"
                                        value={values.shippingAddress.state}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">Select</option>
                                        {states.map((state) => (
                                            <option key={state.isoCode} value={state.name}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                    {touched.shippingAddress?.state && errors.shippingAddress?.state && (
                                        <div className={styles.errorText}>{errors.shippingAddress.state}</div>
                                    )}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                    Zip code
                                    <input
                                        type="text"
                                        name="shippingAddress.zipCode"
                                        placeholder="Enter Zip code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shippingAddress.zipCode}
                                        className={styles.addCatInput}
                                    />
                                    {touched.shippingAddress?.zipCode && errors.shippingAddress?.zipCode ? (
                                        <div className={styles.errorText}>{errors.shippingAddress.zipCode}</div>
                                    ) : null}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                        <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "Save Customer"}</button>
                    </div>
                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Status
                            <select
                                name="activeStatus"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.activeStatus}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.activeStatus && errors.activeStatus && (
                                <div className={styles.errorText}>{errors.activeStatus}</div>
                            )}
                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Level </h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Status
                            <select
                                name="level"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.level}
                            >
                                <option value="">Select...</option>
                                <option value="SILVER">Silver</option>
                                <option value="PLATINUM">Platinum</option>
                                <option value="GOLD">Gold</option>
                            </select>

                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>  Admin manager</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Select Admin
                            <select
                                name="admin"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.admin}
                            >
                                <option value="">Select...</option>
                                {admin?.map((row) => (

                                    <option key={row?._id} value={row?._id}>{row?.name}</option>
                                ))
                                }
                            </select>
                          
                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Customer Credit</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Credit Terms
                            <select
                                name="creditTerms"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.creditTerms}
                            >
                                <option value="">Select...</option>
                                <option value="ADVANCE">100% Advance Payment</option>
                                <option value="15_DAYS">Net 15 Days</option>
                                <option value="30_DAYS">Net 30 Days</option>
                                <option value="45_DAYS">Net 45 Days</option>
                                <option value="60_DAYS">Net 60 Days</option>
                                <option value="90_DAYS">Net 90 Days</option>
                            </select>
                        </label>
                    </div>
                </div>

            </form>
        </>
    );
};

export default AddCustomerForm;
